import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:3001/api";

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // sends HttpOnly session cookie on every request
  timeout: 60000,
});

const SERVER_DOWN_STATUSES = new Set([502, 503, 504]);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || "";

    if (SERVER_DOWN_STATUSES.has(status) && !window.location.pathname.startsWith("/maintenance")) {
      window.location.href = "/maintenance";
      return Promise.reject(error);
    }

    // On 401 from any protected endpoint, redirect to login.
    // Skip /auth/ routes — checkAuth returning 401 is expected when not logged in.
    if (status === 401 && !url.includes("/auth/")) {
      window.location.href = "/login";
    }

    return Promise.reject(error);
  },
);

export default api;
